import { FaRegCircleCheck, FaIndianRupeeSign } from "react-icons/fa6";
import { PiFlowerTulipDuotone } from "react-icons/pi";

let container = "max-w-screen-3xl m-auto p-6";

export const PlanContainer = ({
  title,
  des,
  res,
  img,
  monthAmount,
  yearAmount,
  amount,
  sub_title,
  left_count,
  right_count
}) => {
  let r = left_count 
  let r2 = right_count
  return (
    <div className={container}>
      <div className="flex flex-col items-center py-6">
        <div className="flex justify-center gap-20 flex-wrap">
          <img src={img} alt="img" style={{ width: "350px" }} />
          <div className="flex justify-center items-center flex-col pt-12">
            <h3 className="text-5xl pb-4">{title}</h3>
            <h3 className="text-4xl pb-6 flex gap-6 items-center flex-col">
              <span
                className="flex items-center"
                style={{ color: "#A7C836", fontWeight: 600 }}
              >
                <FaIndianRupeeSign style={{ fontSize: "2rem" }} />
                {monthAmount} / Month
              </span>
              <div className="flex text-3xl flex-wrap justify-center gap-2 items-center">
                <p className="pb-2">or</p>
                <s
                  className="flex text-2xl items-center"
                  style={{ color: "black", fontWeight: 600 }}
                >
                  <FaIndianRupeeSign style={{ fontSize: "1rem" }} />
                  {amount}{" "}
                </s>
                <span
                  className="flex items-center"
                  style={{ color: "#A7C836", fontWeight: 600 }}
                >
                  <FaIndianRupeeSign style={{ fontSize: "2rem" }} />
                  {yearAmount} / year{" "}
                </span>
              </div>
            </h3>
          </div>
        </div>
            <h3 className="text-3xl pt-10 text-[#3B60FA] font-medium">{sub_title}</h3>
        <div
          className={`flex items-center gap-2 pt-12 ${
            res ? "flex-row-reverse" : ""
          }`}
        >
          <div className="flex justify-center plan-details">
            <div className="plan-items" style={{ width: "40%" }}>
              {des.map((arr, i) => {
                if (r > i) {
                  return (
                    <div
                      key={i}
                      className="text-2xl py-2 flex"
                      style={{ lineHeight: "3rem" }}
                    >
                      <div className="tick-icon" style={{ width: "10%" }}>
                        <FaRegCircleCheck
                          style={{
                            color: "#27AE60",
                            width: "3rem",
                            marginTop: "0.8rem",
                          }}
                        />
                      </div>
                      <div style={{ width: "90%" }}>
                        <p>{arr.label}</p>
                        <div>
                          {typeof arr?.value === "object" ? (
                            arr.value.map((arrs, index) => (
                              <div key={index} className="flex gap-2">
                                <p
                                  style={{
                                    display: !arrs && "none",
                                    color: "green",
                                    fontSize: "36px",
                                  }}
                                  className="text-3xl pt-3"
                                >
                                  *
                                </p>
                                <p>{arrs}</p>
                              </div>
                            ))
                          ) : (
                            <>
                              <p
                                style={{
                                  display: !arr.value && "none",
                                  color: "green",
                                  fontSize: "36px",
                                }}
                                className="text-3xl pt-3"
                              >
                                *
                              </p>
                              <p>{arr.value}</p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </div>

            <div className="plan-items" style={{ width: " 40%" }}>
              {des.map((arr, i) => {
                
                if (r2 <= i) {
                  return (
                    <div
                      key={i}
                      className="text-2xl py-2 flex"
                      style={{ lineHeight: "3rem" }}
                    >
                      <div className="tick-icon" style={{ width: "10%" }}>
                        <FaRegCircleCheck
                          style={{
                            color: "#27AE60",
                            width: "3rem",
                            marginTop: "0.8rem",
                          }}
                        />
                      </div>
                      <div style={{ width: "90%" }}>
                        <p>{arr.label}</p>
                        <div>
                          {typeof arr?.value === "object" ? (
                            arr.value.map((arrs, index) => (
                              <div key={index} className="flex gap-2">
                                <p
                                  style={{
                                    display: !arrs && "none",
                                    color: "green",
                                    fontSize: "36px",
                                  }}
                                  className="text-3xl pt-3"
                                >
                                  *
                                </p>
                                <p>{arrs}</p>
                              </div>
                            ))
                          ) : (
                            <>
                              <p
                                style={{
                                  display: !arr.value && "none",
                                  color: "green",
                                  fontSize: "36px",
                                }}
                                className="text-3xl pt-3"
                              >
                                *
                              </p>
                              <p>{arr.value}</p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
